import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cf8ecf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tile",
  style: {"background-color":"#FFD700"}
}
const _hoisted_2 = { class: "text info-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex" }, " Join now for an exclusive ChargEra token boost! ", -1 /* HOISTED */))
const _hoisted_4 = {
  class: "blink_me",
  style: {"font-weight":"bolder","margin-right":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Button, {
        onClick: $setup.onClick,
        class: "secondary"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode("Boost your C4E here!!! "),
            _createVNode($setup["Icon"], {
              name: "Rocket",
              style: {"width":"16px","height":"16px","font-weight":"bolder","margin-right":"4px"}
            }),
            _createVNode($setup["Icon"], {
              name: "Rocket",
              style: {"width":"20px","height":"20px","font-weight":"bolder","margin-right":"4px"}
            }),
            _createVNode($setup["Icon"], {
              name: "Rocket",
              style: {"width":"24px","height":"24px","font-weight":"bolder","margin-right":"4px"}
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}